@switch (tab()) {
  @case (M_T.M) {
    <mn-menu-tab />
  }
  @case (M_T.L) {
    <mn-limits-tab />
  }
  @case (M_T.B) {
    <mn-bets-tab />
  }
  @case (M_T.F) {
    <mn-provably-fair-tab />
  }
  @case (M_T.F_I) {
    <mn-info-tab [type]="I_T.F" />
  }
  @case (M_T.R_I) {
    <mn-info-tab [type]="I_T.R" />
  }
  @case (M_T.H_I) {
    <mn-info-tab [type]="I_T.H" />
  }
}
